<template>
  <div class="content">
    <img :src="imgMap[order.status]" />
    <div>
      <div class="title">{{ order.statusName }}</div>
      <div v-if="order.statusReason" class="desc">
        {{ order.statusReason }}
      </div>
      <div v-if="order.status === 0" class="desc">
        <van-count-down
          :time="order.countDownTime.closeCountDown"
          @finish="handleFinish(order.countDownTime.closeCountDown)"
        >
          <template #default="{ hours, minutes, seconds }">
            {{ `${padLeft(hours)}:${padLeft(minutes)}:${padLeft(seconds)}` }}
          </template>
        </van-count-down>
        关闭订单
      </div>
      <div v-if="order.status === 100 || order.status === 102" class="desc">
        <template v-if="order.countDownTime.shippingCountDown">
          商家将在
          <van-count-down
            :time="order.countDownTime.shippingCountDown"
            @finish="handleFinish(order.countDownTime.shippingCountDown)"
          >
            <template #default="{ days, hours, minutes }">
              {{ `${days}天${hours}时${minutes}分` }}
            </template>
          </van-count-down>
          内发货
        </template>
        <template v-else>
          商家未及时发货
          <span :class="_.contact" @click="handleContactClick">联系客服</span>
        </template>
      </div>
      <div v-if="order.status === 101" class="desc">
        <van-count-down
          :time="order.countDownTime.confirmCountDown"
          @finish="handleFinish(order.countDownTime.confirmCountDown)"
        >
          <template #default="{ days, hours, minutes }">
            {{ `${days}天${hours}时${minutes}分` }}
          </template>
        </van-count-down>
        自动签收
      </div>
    </div>
  </div>
</template>

<script>
  import { dcb } from '@dcb/jssdk'
  import { padStart } from 'vtils'
  export default {
    props: {
      order: {
        type: Object,
        required: true,
      },
    },

    data() {
      return {
        status: 4,
        time: 30 * 60 * 60 * 1000,
      }
    },

    computed: {
      imgMap() {
        return {
          0: require('./images/待支付.png'),
          901: require('./images/已关闭.png'),
          100: require('./images/待发货.png'),
          102: require('./images/已发货.png'),
          101: require('./images/已发货.png'),
          900: require('./images/已完成.png'),
          902: require('./images/已完成.png'),
        }
      },
    },

    methods: {
      padLeft(text) {
        return padStart(text, 2, '0')
      },
      handleFinish(time) {
        // 避免死循环：到了发货时间，商家都没发货，time 为 0
        if (time !== 0) {
          this.$emit('finish')
        }
      },
      handleContactClick() {
        dcb.makeCustomerServicePhoneCall()
      },
    },
  }
</script>

<style scoped lang="scss">
  .content {
    background: #ffffff;
    border-radius: 8px;
    display: flex;
    align-items: center;
    padding: 16px;
    img {
      width: 36px;
      height: 36px;
      flex-shrink: 0;
      margin-right: 16px;
    }
  }
  .title {
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: bold;
    color: #222222;
  }
  .desc {
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #888888;
    padding-top: 4px;
  }
  .van-count-down {
    display: inline-block;
    font-size: 12px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #888888;
  }
</style>

<style lang="scss" module>
  .contact {
    margin-left: 8px;
    height: 17px;
    line-height: 17px;
    border-radius: 100px;
    border: 1px solid #ff3b30;
    font-size: 12px;
    color: #ff3b30;
    padding: 0 8px;
    box-sizing: border-box;

    &:active {
      opacity: 0.9;
    }
  }
</style>
